/* global axios */

class CouponsAPI {
  get(accountId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/coupons`, { params });
  }

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/coupons/${id}`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/coupons`, {
      coupon: payload,
    });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/coupons/${id}`, {
      coupon: payload,
    });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/coupons/${id}`);
  }
}

export default new CouponsAPI();
